module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "third-part-login"
  }, [_c('p', {
    attrs: {
      "id": "sign-in-with"
    }
  }, [_c('span'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('signInWith')))]), _vm._v(" "), _c('span')]), _vm._v(" "), [_c('a', {
    attrs: {
      "href": _vm.twitterLoginURL
    },
    on: {
      "click": _vm.setRedirectUrlCookie
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/oAuthLogin/twitter.png",
      "alt": "twitter"
    }
  })]), _vm._v(" "), (_vm.currentLang === 'zh' && _vm.mediaType === 'pc') ? _c('wechat-login') : _vm._e()], _vm._v(" "), _c('spinner', {
    staticClass: "loading",
    attrs: {
      "show": _vm.isLoading
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d8454934!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginform/oauthLogin/ThirdPartLogin.vue
// module id = 1396
// module chunks = 1